module.exports = __webpack_public_path__ + "img/ba0204ec907915e2ce8038967dc6f299.png";